import BaseError from './BaseError';

class CoachmarkError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('CoachmarkError', message, fileName, lineNumber);
  }
}

export default CoachmarkError;
